import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDPaper, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import TaxDiagnosticMessageFacetIconPicker from './TaxDiagnosticMessageFacetIconPicker/TaxDiagnosticMessageFacetIconPicker';
import TaxDiagnosticMessageInvitationLinkPicker from './TaxDiagnosticMessageInvitationLinkPicker/TaxDiagnosticMessageInvitationLinkPicker';

const TaxDiagnosticMessageLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDPaper width={'100%'} appearance={'flat'} color={'subtle'} padding={6}>
      <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'} spacing={4}>
        <TaxDiagnosticMessageFacetIconPicker resource={resource} />
        <MetaControlField attr={'header'} />
        <MetaControlField attr={'title'} />
        <MetaControlField attr={'subtitle'} />
        <TaxDiagnosticMessageInvitationLinkPicker resource={resource} />
        <MetaControlField attr={'footer'} />
      </FDStack>
    </FDPaper>
  );
};

TaxDiagnosticMessageLayout.defaultProps = {};

TaxDiagnosticMessageLayout.propTypes = {};

export default TaxDiagnosticMessageLayout;
